import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PRODUCTS } from 'src/app/shared/constants/common-constants';
import { CommonService } from 'src/app/shared/services/angular-service/common.services';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';
import { CompanyService } from 'src/app/shared/services/node-api/company.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';

@Component({
  selector: 'app-industry-report-action-component',
  templateUrl: './industry-report-action-component.component.html',
  styleUrls: ['./industry-report-action-component.component.scss'],
})
export class IndustryReportActionComponentComponent implements OnInit {
  companyOverview: any;
  productList: any;
  isAddedInFollowList: any;
  PRODUCTS = PRODUCTS;
  cin: string;
  productType: any;
  sku: string;
  productDetails: any;
  ayList = [];
  selectedYear;
  plan: any;
  isAdvance = false;
  isFree = false;
  isPremium = false;
  loginEmail: any;
  company_name
  product_name
  isProduct: boolean;
  deviceType: string;
  company_url: any;
  isSampleReportVisible: boolean;
  isReportVisible: boolean;
  constructor(
    private companyService: CompanyService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private localStorage: LocalStorageService,
    private localStorageService: LocalStorageService,
    private loginSignupService: LoginSignupService,
    private router: Router,
    private toastService: ToastService,
    private tansactionService: TansactionService,
  ) {
    this.deviceType = localStorage.getItem('deviceType');
    this.route.params.subscribe((params) => {
      this.company_name = params.name;
      this.company_url = params.name.toLowerCase();
      this.company_url = this.company_name.replaceAll(' ', '-');
      this.product_name = params.report;
      this.sku = params.sku.toUpperCase();
      this.cin = this.sku.split('_')[1];
      this.productType = this.commonService.getProductTypeBySku(this.sku);
    });
    this.loginEmail = this.loginSignupService.getUserSession()?.user?.name;
    this.plan = this.localStorageService.getItem('plan');
    this.isProductFree(this.plan)
    if (this.plan === 'plan_advance') {
      this.isAdvance = true;
      this.isPremium = false;
      this.isFree = false;
    } else if (this.plan === 'plan_premium') {
      this.isPremium = true;
      this.isFree = false;
      this.isAdvance = false;
    } else {
      this.isFree = true;
      this.isPremium = false;
      this.isAdvance = false;
    }
  }

  ngOnInit(): void {
    this.isProductFree(this.plan)
    this.companyService.sharedData$.subscribe((data) => {
      if (data) {
        this.companyOverview = data;
        this.isAddedInFollowList = this.commonService.isInFollowlist(
          this.companyOverview._id
        );

        this.productList = this.companyOverview.product_list_arr.filter(
          (item) => item.type === this.productType
        );
        this.generateUnique(this.productList);
        this.ayList.sort(function (a, b) {
          return a.substring(0, 4) - b.substring(0, 4);
        });
        this.onOptionsSelected(this.ayList[this.ayList.length - 1]);
      } else {
        this.getHistoricalData();
      }
    });
  }
  isProductFree(plan) {
    this.isProduct = false;
    if (this.loginEmail == undefined || this.loginEmail == '' || this.loginEmail == null) {
      this.isProduct = false;
    } else {
      if (plan == "plan_premium") {
        this.isProduct = true;
      } else if (plan == "plan_advance") {
        if (this.productType == 'BSS' ||
          this.productType == 'PLS' ||
          this.productType == 'ROC' ||
          this.productType == 'SHS' ||
          this.productType == 'FRO') {
          this.isProduct = false;
        } else {
          this.isProduct = true;
        }
      } else {
        this.isProduct = false;
      }
    }
  }

  getHistoricalData() {
    let request = { cin: this.cin };
    this.companyService
      .getCompanyHistoricalDetails(request)
      .then((data: any) => {
        this.companyOverview = data;

      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  generateUnique(list) {
    list.forEach((product) => {
      if (product.enable && !this.ayList.includes(product.ay)) {
        this.ayList.push(product.ay);
      }
    });
  }

  onOptionsSelected(year) {
    this.selectedYear = year;
    this.productDetails = this.productList.filter((product) => {
      return product.ay === this.selectedYear;
    })[0];
    // console.log(this.productDetails);
  }

  addToCart(sku) {
    if (
      this.loginEmail == undefined ||
      this.loginEmail == '' ||
      this.loginEmail == null
    ) {
      this.localStorageService.setItem("redirect_url", this.router.url);
      this.router.navigate(['/user/login']);
    } else {
      let currentOption;
      currentOption = {
        sku: sku,
      };
      this.tansactionService.addProductToCart(currentOption).then(
        (data: any) => {
          if (this.isProduct == true) {
            this.toastService.addSingle(
              'success',
              'Email Sent',
              'Please check your email.'
            );
          } else {
            this.toastService.addSingle(
              'success',
              'Item added to cart',
              'Make payment to complete this transaction.'
            );
          }
        },
        (err) => {
          this.toastService.addSingle('error', 'Error', err.error.message);
        }
      );
    }
  }

  showSampleReport() {
    this.isSampleReportVisible = !this.isSampleReportVisible;
    this.router.navigate([
      '/company/' +
      this.company_url +
      '/sample/' +
      this.product_name +
      '/' +
      this.sku + '/' + this.isSampleReportVisible,
    ]);
  }

  showReport() {
    this.isReportVisible = true
    this.router.navigate([
      '/company/' +
      this.company_url +
      '/product/' +
      this.product_name +
      '/' +
      this.sku + '/' + this.isReportVisible,
    ]);
  }
}
